import {
  DataBox,
  DataBoxLegendProps,
  DataBoxBaseProps,
} from 'src/components/molecules/DataBox';
import { ValueTickFormatter } from 'src/utils/TickFormatters';
import { Optimization } from '../../types';
import { NewBarGraph } from 'src/components/molecules/graphs/NewBarGraph';

type ROIByMediaBarGraphProps = {
  optimization: Optimization;
} & DataBoxBaseProps;

const INITIAL_KEY = 'Initial ROI';
const OPTIMIZED_KEY = 'Optimized ROI';

export const ROIByMediaBarGraph: React.FC<ROIByMediaBarGraphProps> = ({
  optimization,
  ...dataBoxProps
}) => {
  const data = optimization.data.map((opt) => ({
    [INITIAL_KEY]: opt.roi.initial,
    [OPTIMIZED_KEY]: opt.roi.optimized,
    channel: opt.channelName,
  }));

  const dataKeys = {
    xAxis: 'channel',
    data: [INITIAL_KEY, OPTIMIZED_KEY],
  };

  const legendProps: DataBoxLegendProps = {
    baseLegendKeys: dataKeys.data,
    placement: 'top',
  };

  return (
    <DataBox
      {...dataBoxProps}
      legendProps={legendProps}
      isError={false}
      isLoading={false}
      hasData={data.length > 0}>
      <NewBarGraph
        data={data}
        xAxisKey={dataKeys.xAxis}
        stacked={false}
        yAxisFormatter={ValueTickFormatter}
      />
    </DataBox>
  );
};
